(function () {
  const rootSelector = '.template-search';
  const enhancedClass = 'ab-sort-native';

  function closeMenus(except) {
    document.querySelectorAll('.ab-search-sort[data-open="true"]').forEach((menu) => {
      if (menu !== except) menu.setAttribute('data-open', 'false');
    });
  }

  function syncMenu(select, menu) {
    const current = select.options[select.selectedIndex];
    const label = menu.querySelector('[data-ab-sort-label]');
    if (label && current) label.textContent = current.textContent.trim();
    menu.querySelectorAll('[data-ab-sort-value]').forEach((button) => {
      const isSelected = button.dataset.abSortValue === select.value;
      button.setAttribute('aria-selected', String(isSelected));
    });
  }

  function enhanceSelect(select) {
    if (select.dataset.abSortEnhanced === 'true') return;

    const wrapper = select.closest('.select');
    if (!wrapper) return;

    select.dataset.abSortEnhanced = 'true';
    select.classList.add(enhancedClass);
    wrapper.classList.add('ab-sort-ready');

    const menu = document.createElement('div');
    menu.className = 'ab-search-sort';
    menu.setAttribute('data-open', 'false');

    const trigger = document.createElement('button');
    trigger.type = 'button';
    trigger.className = 'ab-search-sort__trigger';
    trigger.setAttribute('aria-haspopup', 'listbox');
    trigger.setAttribute('aria-expanded', 'false');
    trigger.innerHTML = '<span data-ab-sort-label></span><span class="ab-search-sort__caret" aria-hidden="true"></span>';

    const list = document.createElement('div');
    list.className = 'ab-search-sort__menu';
    list.setAttribute('role', 'listbox');

    Array.from(select.options).forEach((option) => {
      const item = document.createElement('button');
      item.type = 'button';
      item.className = 'ab-search-sort__option';
      item.dataset.abSortValue = option.value;
      item.setAttribute('role', 'option');
      item.textContent = option.textContent.trim();
      item.addEventListener('click', () => {
        select.value = option.value;
        syncMenu(select, menu);
        closeMenus();
        select.dispatchEvent(new Event('input', { bubbles: true }));
        select.dispatchEvent(new Event('change', { bubbles: true }));
      });
      list.appendChild(item);
    });

    trigger.addEventListener('click', (event) => {
      event.preventDefault();
      const isOpen = menu.getAttribute('data-open') === 'true';
      closeMenus(menu);
      menu.setAttribute('data-open', String(!isOpen));
      trigger.setAttribute('aria-expanded', String(!isOpen));
    });

    select.addEventListener('change', () => syncMenu(select, menu));
    menu.append(trigger, list);
    wrapper.appendChild(menu);
    syncMenu(select, menu);
  }

  function initSortMenus() {
    document.querySelectorAll(`${rootSelector} .facet-filters__sort`).forEach(enhanceSelect);
  }

  document.addEventListener('click', (event) => {
    if (!event.target.closest('.ab-search-sort')) closeMenus();
  });

  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape') closeMenus();
  });

  document.addEventListener('DOMContentLoaded', initSortMenus);
  initSortMenus();

  new MutationObserver(initSortMenus).observe(document.documentElement, {
    childList: true,
    subtree: true,
  });
})();
